// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"32":"9dcb7d11","60":"30625699","576":"0834d55b"}[chunkId] + ".chunk.css";
};